import { render, staticRenderFns } from "./comHeader.vue?vue&type=template&id=025b8038&scoped=true&"
import script from "./comHeader.vue?vue&type=script&lang=js&"
export * from "./comHeader.vue?vue&type=script&lang=js&"
import style0 from "./comHeader.vue?vue&type=style&index=0&id=025b8038&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025b8038",
  null
  
)

export default component.exports